var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SentNotificationModal',{attrs:{"open":_vm.showSentNotificationModal,"notifications":_vm.notifications.data.notifications},on:{"update:open":function($event){_vm.showSentNotificationModal=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }